export class ModalDialog extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!(this.dialog instanceof HTMLDialogElement)) return;

    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;

    this.dialog.addEventListener('cancel', this.onCancel, { signal });
    this.dialog.addEventListener('click', this.onDialogClick, { signal });
    this.dialog.addEventListener('close', this.onClose, { signal });
    this.addEventListener('click', this.onCloseClick, { signal });
    this.addEventListener('keydown', this.onKeydown, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    if (this.dialog?.open) this.dialog.close();
  }

  open(trigger) {
    if (!this.dialog || this.dialog.open) return;

    this.returnFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
    this.dialog.showModal();
    requestAnimationFrame(() => {
      const initialFocus = this.querySelector('[data-dialog-initial-focus]') || this.querySelector('[data-dialog-close]');
      if (initialFocus instanceof HTMLElement) initialFocus.focus({ preventScroll: true });
    });
    this.dispatchEvent(new CustomEvent('dialog:open', { bubbles: true }));
  }

  close() {
    if (this.dialog?.open) this.dialog.close();
  }

  onCancel = (event) => {
    event.preventDefault();
    this.close();
  };

  onCloseClick = (event) => {
    if (!event.target.closest('[data-dialog-close]')) return;
    event.preventDefault();
    this.close();
  };

  onKeydown = (event) => {
    if (event.key !== 'Escape') return;

    event.preventDefault();
    this.close();
  };

  onDialogClick = (event) => {
    if (event.target !== this.dialog) return;

    const bounds = this.dialog.getBoundingClientRect();
    const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
    if (outside) this.close();
  };

  onClose = () => {
    if (this.returnFocus instanceof HTMLElement && this.returnFocus.isConnected) {
      this.returnFocus.focus({ preventScroll: true });
    }
    this.dispatchEvent(new CustomEvent('dialog:close', { bubbles: true }));
  };
}

if (!customElements.get('modal-dialog')) customElements.define('modal-dialog', ModalDialog);
